export function getGPIFieldErrorMessage(customErrors, field) {
  return customErrors
    ?.filter(c => c.field === field)
    .map(c => c.errorMessage)
    .filter((v, i, a) => a.indexOf(v) === i)
    .join(' ')
}
